// 空状态生成器：景点卡（poi）
export function createEmptyPoiPayload() {
  return {
    card_type: 'poi',
    type: 'poi',
    title: '请输入景点名称',
    imageUrl: 'https://images.unsplash.com/photo-1464983953574-0892a716854b?w=1200&h=600&fit=crop&auto=format',
    address: '请填写景点地址',
    description: '这里请填写景点的描述',
    metaPairs: [],
    tags: [],
    card: {},
  };
}
